/**
 * Created by istvan.rozsa on 2017. 04. 20..
 */

export default function () {
	return function (form, password, passwordAgain) {
		form.$setValidity('mismatch', password == passwordAgain);
	};
};
